import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';

export interface Panel {
  name: string;
  description: string;
  details: string[];
  active: boolean;
}

@Component({
  selector: 'id-document',
  standalone: true,
  imports: [NzCollapseModule, TranslateModule],
  templateUrl: './id-document.component.html',
  styleUrl: './id-document.component.scss'
})
export class IdDocumentComponent {
  @Output() closeAllPanels = new EventEmitter<void>();
  @Output() panelToggled = new EventEmitter<void>();

  public idDocument: any = {
    title: 'okeeyCash.idDocument.title',
    ssn: 'okeeyCash.idDocument.ssn',
    mexicanID: 'okeeyCash.idDocument.mexicanID',
    remember: 'okeeyCash.idDocument.remember',
    panels: [
      {
        name: 'okeeyCash.idDocument.primaryIdDocument',
        description: 'okeeyCash.idDocument.mainMexicanID',
        details: [
          'okeeyCash.idDocument.mexicanINE',
          'okeeyCash.idDocument.mexicanPassport',
          'okeeyCash.idDocument.mexicanDriverLicense',
          'okeeyCash.idDocument.mexicanConsularId',
          'okeeyCash.idDocument.UsDriverLicense'
        ],
        active: false
      },
      {
        name: 'okeeyCash.idDocument.supportingDocument',
        description: 'okeeyCash.idDocument.secondId',
        details: [
          'okeeyCash.idDocument.USphoneBill',
          'okeeyCash.idDocument.USWaterBill',
          'okeeyCash.idDocument.USGASBill',
          'okeeyCash.idDocument.USMonthlyBill',
          'okeeyCash.idDocument.USPayStub',
          'okeeyCash.idDocument.USBankStatement',
          'okeeyCash.idDocument.letterHead',
          'okeeyCash.idDocument.UsDriverLicense',
          'okeeyCash.idDocument.IneMexico',
          'okeeyCash.idDocument.passportMexico',
          'okeeyCash.idDocument.licenseMexico',
          'okeeyCash.idDocument.consularIdmexico'
        ],
        active: false
      }
    ]
  };

  public closePanels() {
    this.idDocument.panels.forEach(panel => (panel.active = false));
    this.panelToggled.emit();
  }
}
